import { render, staticRenderFns } from "./AgencyComposition.vue?vue&type=template&id=5a4b6b1c&scoped=true&"
import script from "./AgencyComposition.vue?vue&type=script&lang=js&"
export * from "./AgencyComposition.vue?vue&type=script&lang=js&"
import style0 from "./AgencyComposition.vue?vue&type=style&index=0&id=5a4b6b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b6b1c",
  null
  
)

export default component.exports